import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DvSettingsMenuItem } from '@devinco/ui/legacy';
import {
  integrationsMenuItemLinks,
  integrationsMenuItemTitle,
} from './constants';
import { SettingsGroupPageComponent } from '@pages/settings-page/settings-group-page/settings-group-page.component';
import { SettingsMenuItemPermissionsPipe } from '@shared/pipes/settings-menu-item-permissions.pipe';
import { AsyncPipe } from '@angular/common';

@Component({
  imports: [
    SettingsGroupPageComponent,
    SettingsMenuItemPermissionsPipe,
    AsyncPipe,
  ],
  selector: 'app-integration-settings',
  templateUrl: './integration-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../styles/settings-group-page-host-styles.scss'],
})
export class IntegrationSettingsComponent {
  integrationsMenuItemTitle = integrationsMenuItemTitle;
  settingsMenuItems: DvSettingsMenuItem[] = integrationsMenuItemLinks.map(
    link => ({
      ...link,
      link: link.routerLink,
    })
  );
}
